module.exports = __webpack_public_path__ + "static/quiz_question_girl_boy_bg_mobile-18e3def639ab67bbc1b96f8608a3d834.svg";